import { IPlayUIStateProps } from "../..";
import { store } from "../../..";
import { API } from "../../../../legacy/api";
import { LegacyEvent } from "../../../../legacy/api";
import * as validate from "../../../validation";
import * as actions from "../../Keypad/Common/Keypad.actions";
import { IGameSetting } from "./Keypad.actions";

const getState = () => {
  return (store.getState() as IPlayUIStateProps).keypad;
};

API.on("playforfun.show", () => {
  const { isPlayingForFun } = getState();

  if (!isPlayingForFun) {
    store.dispatch(actions.setPlayForFunActive(true));
  }
});

API.on("playforfun.hide", () => {
  const { isPlayingForFun } = getState();

  if (isPlayingForFun) {
    store.dispatch(actions.setPlayForFunActive(false));
  }
});

API.on("lefthandmode.enable", () => {
  const { isLeftHandMode } = getState();

  if (!isLeftHandMode) {
    store.dispatch(actions.setLeftHandModeActive(true));
  }
});

API.on("lefthandmode.disable", () => {
  const { isLeftHandMode } = getState();

  if (isLeftHandMode) {
    store.dispatch(actions.setLeftHandModeActive(false));
  }
});

API.on("fullscreen.canvas.activate", () => {
  const { isFullscreenGame } = getState();

  if (!isFullscreenGame) {
    store.dispatch(actions.setFullscreenCanvasActive(true));
  }
});

API.on("fullscreen.canvas.deactivate", () => {
  const { isFullscreenGame } = getState();

  if (isFullscreenGame) {
    store.dispatch(actions.setFullscreenCanvasActive(false));
  }
});

API.on("quickspin.enabled.set", enabled => {
  store.dispatch(actions.setQuickSpinEnabled(enabled));
});

API.on("quickspin.active.set", active => {
  store.dispatch(actions.setQuickSpinActive(active));
});

API.on("quickspin.available.set", available => {
  store.dispatch(actions.setQuickSpinAvailable(available));
});

API.on("gamesettings.set", (settings: IGameSetting[]) => {
  const { gameSettings } = getState();

  if (validate.gameSettings(settings, gameSettings)) {
    store.dispatch(actions.setGameSettings(settings));
  }
});

API.on("volume.set", (volume: number) => {
  if (validate.volume(volume, "volume.set")) {
    store.dispatch(actions.setVolume(volume));
  }
});

API.on("sound.mute", () => {
  store.dispatch(actions.muteSound(true));
});

API.on("sound.unmute", () => {
  store.dispatch(actions.muteSound(false));
});

API.on("spin.start", () => {
  store.dispatch(actions.startSpin());
});

API.on("spin.quickstop", () => {
  store.dispatch(actions.disableKeypadButton("spin"));
});

API.on("spin.winpresentation", () => {
  store.dispatch(actions.enableKeypadButton("spin"));
});

API.on("spin.idle", () => {
  store.dispatch(actions.stopSpin());
});

const buttons = ["menu", "autoplay", "spin", "bet", "sound", "quickspin"];

buttons.forEach(button => {
  const enableEvent = `${button}button.enable` as LegacyEvent;
  const disabledEvent = `${button}button.disable` as LegacyEvent;

  API.on(enableEvent, () => {
    store.dispatch(actions.enableKeypadButton(button));
  });

  API.on(disabledEvent, () => {
    store.dispatch(actions.disableKeypadButton(button));
  });
});
